import React from "react";

const GlobalTravelsAbout = () => {
  const brandPurple = "#bd06b3";
  const brandCyan = "#00bfff";

  return (
    <div
      style={{
        fontFamily: "sans-serif",
        color: "#333",
        backgroundColor: "#fff",
        marginTop: "-50px",
      }}
    >
      <div
        style={{
          maxWidth: "1440px",
          margin: "0 auto",
          padding: "60px 20px",
        }}
      >
        {/* Top Section */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "40px",
            alignItems: "center",
            marginBottom: "70px",
          }}
        >
          {/* Image */}
          <div style={{ flex: "1 1 450px" }}>
            <img
              src="https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=1000&q=80"
              alt="Airplane Flight"
              style={{
                width: "100%",
                height: "380px",
                objectFit: "cover",
                borderRadius: "12px",
              }}
            />
          </div>

          {/* Content */}
          <div style={{ flex: "1 1 500px" }}>
            <h2
              style={{
                fontSize: "30px",
                color: "#0f172a",
                marginBottom: "15px",
                lineHeight: "1.3",
              }}
            >
              Travel Made Simple,{" "}
              <span style={{ color: brandPurple }}>Personal & Reliable</span>
            </h2>

            <p
              style={{
                color: "#64748b",
                lineHeight: "1.7",
                fontSize: "14px",
                marginBottom: "15px",
              }}
            >
              At Iconic Holidays, we believe travel should be exciting rather
              than complicated. Our goal is to provide thoughtful travel
              solutions that help individuals, families, professionals, and
              organizations travel with confidence.
            </p>

            <p
              style={{
                color: "#64748b",
                lineHeight: "1.7",
                fontSize: "14px",
                marginBottom: "25px",
              }}
            >
              As a member of the Iconic Unity Group, we are part of a broader
              ecosystem built around innovation, service, and long-term value.
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "15px",
              }}
            >
              <div
                style={{
                  background: "#fafafa",
                  padding: "15px",
                  borderRadius: "8px",
                  border: "1px solid #eee",
                }}
              >
                <h4
                  style={{
                    margin: "0 0 5px",
                    fontSize: "14px",
                    color: brandPurple,
                  }}
                >
                  Global Reach
                </h4>

                <p
                  style={{
                    margin: 0,
                    fontSize: "12px",
                    color: "#64748b",
                  }}
                >
                  Travel opportunities beyond borders.
                </p>
              </div>

              <div
                style={{
                  background: "#fafafa",
                  padding: "15px",
                  borderRadius: "8px",
                  border: "1px solid #eee",
                }}
              >
                <h4
                  style={{
                    margin: "0 0 5px",
                    fontSize: "14px",
                    color: brandCyan,
                  }}
                >
                  Trusted Service
                </h4>

                <p
                  style={{
                    margin: 0,
                    fontSize: "12px",
                    color: "#64748b",
                  }}
                >
                  Reliable support throughout your journey.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Mission & Vision */}
        <div style={{ textAlign: "center", marginBottom: "70px" }}>
          <h2
            style={{
              fontSize: "26px",
              color: "#0f172a",
              margin: "0 0 8px",
            }}
          >
            Built Around Purpose
          </h2>

          <p
            style={{
              color: "#64748b",
              fontSize: "13px",
              maxWidth: "600px",
              margin: "0 auto 35px",
            }}
          >
            Better travel experiences come from better planning, better service,
            and genuine care for every traveler.
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
              gap: "25px",
            }}
          >
            {/* Mission */}
            <div
              style={{
                background: "#fff",
                padding: "30px 25px",
                borderRadius: "10px",
                border: "1px solid #e2e8f0",
                textAlign: "left",
              }}
            >
              <div
                style={{
                  width: "38px",
                  height: "38px",
                  borderRadius: "8px",
                  background: "#fff5fe",
                  color: brandPurple,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "15px",
                  fontWeight: "bold",
                }}
              >
                🎯
              </div>

              <h3
                style={{
                  fontSize: "20px",
                  margin: "0 0 10px",
                  color: "#0f172a",
                }}
              >
                Our Mission
              </h3>

              <p
                style={{
                  margin: 0,
                  fontSize: "13px",
                  color: "#64748b",
                  lineHeight: "1.6",
                }}
              >
                To make travel more accessible, organized, and dependable by
                delivering customer-focused travel solutions with transparency,
                care, and professionalism.
              </p>
            </div>

            {/* Vision */}
            <div
              style={{
                background: "#fff",
                padding: "30px 25px",
                borderRadius: "10px",
                border: "1px solid #e2e8f0",
                textAlign: "left",
              }}
            >
              <div
                style={{
                  width: "38px",
                  height: "38px",
                  borderRadius: "8px",
                  background: "#f0fbff",
                  color: brandCyan,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "15px",
                  fontWeight: "bold",
                }}
              >
                👁
              </div>

              <h3
                style={{
                  fontSize: "20px",
                  margin: "0 0 10px",
                  color: "#0f172a",
                }}
              >
                Our Vision
              </h3>

              <p
                style={{
                  margin: 0,
                  fontSize: "13px",
                  color: "#64748b",
                  lineHeight: "1.6",
                }}
              >
                To become a trusted travel brand that connects people with
                destinations around the world while creating meaningful and
                seamless travel experiences.
              </p>
            </div>
          </div>
        </div>

        {/* Why Choose Us */}
        <div style={{ textAlign: "center", marginBottom: "70px" }}>
          <h2
            style={{
              fontSize: "26px",
              color: "#0f172a",
              margin: "0 0 8px",
            }}
          >
            Why Iconic Holidays
          </h2>

          <p
            style={{
              color: "#64748b",
              fontSize: "13px",
              maxWidth: "600px",
              margin: "0 auto 35px",
            }}
          >
            We focus on trust, convenience, and service quality to build
            long-term relationships with our travelers.
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
              gap: "20px",
            }}
          >
            {[
              {
                title: "Customer Focused",
                desc: "Every journey starts with understanding our customer's needs and expectations.",
              },
              {
                title: "Reliable Service",
                desc: "Clear communication and dependable travel support throughout your journey.",
              },
              {
                title: "Global Perspective",
                desc: "Explore opportunities and destinations beyond borders.",
              },
              {
                title: "Dedicated Support",
                desc: "Our team supports customers throughout their travel planning journey.",
              },
            ].map((card, idx) => (
              <div
                key={idx}
                style={{
                  background: "#fff",
                  padding: "25px",
                  borderRadius: "10px",
                  border: "1px solid #e2e8f0",
                  textAlign: "left",
                }}
              >
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "7px",
                    background: idx % 2 === 0 ? "#fff5fe" : "#f0fbff",
                    color: idx % 2 === 0 ? brandPurple : brandCyan,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "12px",
                    fontWeight: "bold",
                  }}
                >
                  ✓
                </div>

                <h4
                  style={{
                    margin: "0 0 8px",
                    fontSize: "15px",
                    color: "#0f172a",
                  }}
                >
                  {card.title}
                </h4>

                <p
                  style={{
                    margin: 0,
                    fontSize: "12px",
                    color: "#64748b",
                    lineHeight: "1.5",
                  }}
                >
                  {card.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div
          style={{
            background: "#bd06b3",
            padding: "45px 30px",
            borderRadius: "12px",
            color: "#fff",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              margin: "0 0 10px",
              fontSize: "27px",
            }}
          >
            Ready to Plan Your Next Journey?
          </h2>

          <p
            style={{
              margin: "0 auto 25px",
              fontSize: "14px",
              opacity: 0.9,
              maxWidth: "500px",
            }}
          >
            Let Iconic Holidays help you turn your travel plans into a smooth
            and memorable experience.
          </p>

          <button
            style={{
              background: "#fff",
              color: brandPurple,
              border: "none",
              padding: "11px 25px",
              borderRadius: "6px",
              fontWeight: "bold",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Explore Our Services →
          </button>
        </div>
      </div>
    </div>
  );
};

export default GlobalTravelsAbout;
